import React from 'react';
import { ActionButton } from '@fabric-ui/components/Table';
import { StarFull, StarLine } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box } from '@mui/material';
import { App } from '../../types/sideBar.types';
import { Link } from '../../utils/AvRouter';

const starFullIcon = <StarFull style={{ color: 'var(--color-yellow-150)', ...iconSize(20) }} />;
const starLineIcon = <StarLine style={iconSize(20)} />;

interface AppItemProps extends App {
  isSelected: boolean;
  isFavorite?: boolean;
  showDescription?: boolean;
  to?: string;
  toggleFavoriteApp?: () => void;
  appIconSize?: number;
  isDropdownItem?: boolean;
}
export const AppItem: React.FC<AppItemProps> = ({
  name,
  icon,
  imageFull,
  appIconSize,
  isSelected,
  to,
  showDescription,
  isFavorite = true,
  toggleFavoriteApp,
  description,
  isDropdownItem = false,
}) => (
  <Link to={to}>
    <Box sx={theme => appIconStyle(theme, isSelected, appIconSize, imageFull, isDropdownItem)}>
      {toggleFavoriteApp &&
        ActionButton(isFavorite ? 'Remove from favorite' : 'Add to Favorite', toggleFavoriteApp, isFavorite ? starFullIcon : starLineIcon)}
      <Box sx={{ borderRadius: '8px', position: 'relative' }}>
        <Box className="icon-container">{icon}</Box>
      </Box>
      <Box sx={{ ...flex.col }}>
        <Box sx={{ fontWeight: 600 }}>{name}</Box>
        {showDescription && <Box sx={{ fontWeight: 400, color: 'var(--color-content-base-secondary)' }}>{description}</Box>}
      </Box>
    </Box>
  </Link>
);
export const appIconStyle = (theme, isSelected, appIconSize = 22, imageFull = undefined, isDropdownItem = false) => {
  const hoverColor = isDropdownItem ? undefined : 'var(--color-surface-nav-topBar-hover)';
  const selectedColor = isDropdownItem ? 'var(--color-surface-list-focus)' : 'var(--color-surface-nav-topBar-active)';
  const textColor = isDropdownItem ? 'var(--color-content-base-primary)' : 'var(--color-content-immutable-white)';

  return {
    ...flex.center,
    pl: '4px',
    pr: '12px',
    py: '4px',
    gap: '8px',
    borderRadius: '10px',
    cursor: 'pointer',
    color: textColor,
    transition: theme.transitions.create(['opcaity', 'background-color'], {
      duration: theme.transitions.duration.short,
    }),
    svg: {
      ...iconSize(appIconSize),
    },
    ...opacityGradientBgColor(theme, imageFull, isDropdownItem),
    '.icon-container': {
      p: '5px',
      borderRadius: '8px',
      ...flex.center,
    },
    ':hover': {
      backgroundColor: hoverColor,
      '.icon-container::before': { opacity: 1 },
    },
    ...(isSelected
      ? {
          '.icon-container::before': { opacity: 1 },
          backgroundColor: selectedColor,
          ':hover': {
            backgroundColor: hoverColor,
          },
        }
      : {}),
  };
};

export const appBarItemSelectedStyle = {
  svg: {
    color: 'var(--color-content-immutable-white)',
    ...iconSize(22),
  },
  borderColor: 'transparent',
  background: 'var(--color-surface-nav-topBar-active)',
};
export const appBarItemHoveredStyle = {
  ':hover': {
    background: 'var(--color-surface-nav-topBar-hover)',
    color: 'var(--color-content-immutable-white)',
  },
};

const opacityGradientBgColor = (theme, fullImage, shouldShow) => ({
  '.icon-container:before': {
    background: `url("${fullImage}")`,
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short,
    }),
    content: '" "',
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '32px',
    height: '32px',
    opacity: shouldShow ? 1 : 0,
  },
});
